var LoginService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { LoginComponent } from "../../../core/login/login.component";
import { Router } from "@angular/router";
import { AuthService } from "../auth/auth.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { LocalStorageService } from "../storage/local-storage.service";
import { LocalStorageEnum } from "../storage/local-storage-constants";
let LoginService = class LoginService {
    static { LoginService_1 = this; }
    dialog;
    router;
    authService;
    localStorage;
    loginDialogues = new Array();
    ngUnsubscribe = new Subject();
    constructor(dialog, router, authService, localStorage) {
        this.dialog = dialog;
        this.router = router;
        this.authService = authService;
        this.localStorage = localStorage;
    }
    static getLoginDialogConfig() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        return dialogConfig;
    }
    openLoginDialog(returnURL, loginSuccessEvent) {
        if (this.loginDialogues.length > 0) {
            return;
        }
        this.localStorage.remove(LocalStorageEnum.Login);
        const dialogRef = this.dialog.open(LoginComponent, LoginService_1.getLoginDialogConfig());
        this.loginDialogues.push(dialogRef);
        this.handleDialogClosed(dialogRef, returnURL, loginSuccessEvent);
        return dialogRef;
    }
    closeAllDialogues() {
        if (this.loginDialogues.length > 0) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
            this.ngUnsubscribe = new Subject();
            this.loginDialogues.forEach(item => item.close());
            this.loginDialogues = new Array();
        }
    }
    logOut() {
        this.authService.unAuthenticate();
        this.openLoginDialog();
    }
    handleDialogClosed(dialogRef, returnURL, loginSuccessEvent) {
        dialogRef.afterClosed()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
            if (data) {
                this.closeAllDialogues();
                this.checkReturnURL(returnURL);
                if (loginSuccessEvent) {
                    loginSuccessEvent();
                }
            }
        });
    }
    checkReturnURL(returnURL) {
        if (returnURL) {
            this.navigateReturnURL(returnURL);
        }
    }
    navigateReturnURL(returnURL) {
        this.router.navigateByUrl(returnURL);
    }
    static ctorParameters = () => [
        { type: MatDialog },
        { type: Router },
        { type: AuthService },
        { type: LocalStorageService }
    ];
};
LoginService = LoginService_1 = __decorate([
    Injectable({
        providedIn: "root"
    })
], LoginService);
export { LoginService };
